// Zillow Marketing Breakpoints
const size = {
    extraSmall: '320px',
    small: '576px',
    medium: '768px',
    large: '992px',
    extraLarge: '1280px',
    superWide: '1600px',
};

export default {
    extraSmall: `(min-width: ${size.extraSmall})`,
    small: `(min-width: ${size.small})`,
    medium: `(min-width: ${size.medium})`,
    large: `(min-width: ${size.large})`,
    extraLarge: `(min-width: ${size.extraLarge})`,
    superWide: `(min-width: ${size.superWide})`,
};
